'use client';

import { Toaster } from 'sonner';
import type { ReactNode } from 'react';

import { DevToolsProvider } from '@/providers/dev-tools-provider';
import { QueryProvider } from '@/providers/query-provider';
import { SessionCoordinator } from '@/providers/session-coordinator';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <SessionCoordinator />
      {children}
      <Toaster richColors closeButton />
      <DevToolsProvider />
    </QueryProvider>
  );
}
